import qs from 'qs';
import client from './client';

const commonCodeUrl = '/api/v1/common';

//코드 리스트 가져오기
export const getComCodes = (searchData) =>{
  const queryString = qs.stringify(searchData);
  return client.get(`${commonCodeUrl}/list?${queryString}`);
}

//코드 추가
export const addComCode = (dataToSubmit) => {
  return client.post(`${commonCodeUrl}/info`, dataToSubmit);
};

//코드 정보
export const getCode = (id) => client.get(`${commonCodeUrl}/info/${id}`);

export const editCode = (id, dataToSubmit) => {
  return client.put(`${commonCodeUrl}/info/${id}`, dataToSubmit);
};

//코드 삭제
export const removeCode = (id) => client.delete(`${commonCodeUrl}/info/${id}`);
